// Auth now mirrors the swebapp webapp exactly: login/refresh hit the v2 auth
// service on api2.smilefy.app (Cognito v2 pool), and the v2 idToken is what every
// data call sends as `Authorization` — the same idToken the webapp uses against
// api.smilefy.app. See src/services/instance.js for the request header.
const AUTH_BASE =
  process.env.REACT_APP_AUTH_SERVICE_URL || "https://api2.smilefy.app";

async function authPost(path, body) {
  const res = await fetch(`${AUTH_BASE}${path}`, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error((data && data.error) || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export default class AuthService {
  // POST /auth/login → { result: { idToken:{jwtToken,payload}, refreshToken:{token} } }
  static login = async (username, password) => {
    try {
      const data = await authPost("/auth/login", { username, password });
      const result = data && data.result;
      if (!result) {
        return { success: false, msg: ["No token received from login"] };
      }
      return { success: true, data: result, msg: ["success"] };
    } catch (e) {
      const msg =
        (e.data && (e.data.error || e.data.message)) ||
        e.message ||
        "Something went wrong!";
      return { success: false, msg: [msg] };
    }
  };

  // POST /auth/refresh → { data: { data: { idToken:{jwtToken}, refreshToken:{token} } } }
  // Same triple-nested envelope the webapp reads.
  static tokenRefresh = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) return;
      const data = await authPost("/auth/refresh", { refreshToken });
      const inner = data && data.data && data.data.data;
      const idToken = inner && inner.idToken && inner.idToken.jwtToken;
      const newRefresh = inner && inner.refreshToken && inner.refreshToken.token;
      if (idToken) {
        localStorage.setItem("idToken", idToken);
        localStorage.setItem("authToken", idToken);
      }
      // Cognito REFRESH_TOKEN_AUTH usually doesn't reissue a refresh token.
      if (newRefresh) localStorage.setItem("refreshToken", newRefresh);
    } catch (e) {
      console.error(e);
    }
  };

  // Identity snapshot decoded from the v2 idToken (no round-trip), like the
  // webapp's getAuthUser. Aliases capitalised keys for Drive's existing UI.
  static user = async () => {
    try {
      const token = localStorage.getItem("idToken");
      if (!token) return undefined;
      const parts = token.split(".");
      if (parts.length !== 3) return undefined;
      const claims = JSON.parse(
        atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"))
      );
      return {
        ...claims,
        Name: claims.name,
        FamilyName: claims.family_name,
      };
    } catch (e) {
      console.error(e);
      return undefined;
    }
  };
}